import React from "react";
import styled from 'styled-components';
import Button from '../../../atoms/button';

const Container = styled.div`
  align-self: center;
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 25px 20px;
  background-color: white;
  border: 1px solid #e7e6e6;
  box-shadow: 0 1px 3px 0 rgba(0,0,0,0.15);
  overflow: hidden;
  margin: 16px;
`;

const TextBox = styled.div`
  white-space: pre-wrap;
  color: #626469;
  font-weight: 400;
`;

const Title = styled(TextBox)`
  font-size: 24px;
  letter-spacing: 0.19px;
  line-height: 28px;
  margin-bottom: 15px;
`;

const Text = styled(TextBox)`
  font-size: 16px;
  letter-spacing: 0.13px;
  line-height: 18px;
  margin-bottom: 15px;
`;

const ButtonArea = styled.div`
  display: flex;
`;

class ModalInformation extends React.PureComponent {

  handleButtonClick = () => this.props.onButtonClick();

  render = () => {
    const { title, text, buttonText } = this.props;
    return (
      <Container>
        <Title>{title}</Title>
        <Text>{text}</Text>
        <ButtonArea>
          <Button importance="emphasized" primary option="outline" onClick={this.handleButtonClick}>
            {buttonText}
          </Button>
        </ButtonArea>
      </Container>
    );
  }
}

export default ModalInformation;
